<template>
  <div class="container capacityDetail">
    <div class="searchBox_top">
      <el-button type="primary" v-if="emplFlag=='SUP' && status=='new'" @click="saveDetail()">{{$t('common.saveDraft')}}</el-button>
      <!--保存-->
      <el-button type="primary" v-if="emplFlag=='SUP' && status=='new'" @click="submitDetail()">{{$t('common.submit')}}</el-button>
      <!--提交-->
      <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
    </div>
    <el-card class="box-card" style="margin-top:40px">
      <div slot="header" class="clearfix">
        <span>{{$t('capacity.DetailedInvestigation')}}</span>
      </div>
      <div class="searchBox_bottom">
        <el-button type="primary" size="mini" @click="addDetail" v-if="emplFlag=='SUP' && status=='new'">{{$t('common.add')}}</el-button>
        <!--添加-->
        <el-button type="danger" size="mini" @click="delDetatil" v-if="emplFlag=='SUP' && status=='new'">{{$t('common.del')}}</el-button>
        <el-button type="primary" size="mini" style="margin-right:10px" @click="templateDownload" v-if="emplFlag=='SUP' && status=='new'">{{$t('capacity.downloadWrite')}}</el-button>
        <!--模板下载-->
        <el-button type="primary" size="mini" style="margin-right:10px" @click="dowloadAllSupZip" v-if="emplFlag!='SUP' && capacityDetail.status=='completed'">{{$t('common.bulkDownload')}}</el-button>
        <!--批量下载-->
        <el-upload v-if="emplFlag=='SUP' && status=='new'" ref="upload" action="upload" :http-request="templateUpload" :show-file-list="false" multiple name="file">
          <el-button slot="trigger" size="mini" type="primary">{{$t('common.upload')}}</el-button>
          <!--导入-->
        </el-upload>
      </div>
      <div>
        <el-table v-if="!isSupplier" :data="supplierCapacityList" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip min-width="120" prop="supplierCode" :label="$t('capacity.supplierCode')"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="supplierNameShort" :label="$t('capacity.supplierNameShort')"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="updateDate" :label="$t('capacity.updateDate1')"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="statusI18n" :label="$t('capacity.statusI18n')"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="250" prop="" :label="$t('capacity.attachmentDownload')">
            <template slot-scope="scope" v-if="scope.row.status=='completed'">
              <el-link :key="index" v-for="(item,index) in scope.row.supDoc" type="primary" @click.native.prevent="downloadFile(item)">{{item.documentName}}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="searchBox_bottom">
        <el-button type="primary" size="mini" style="margin-right:10px" @click="templateDownload" v-if="emplFlag!='SUP' && capacityDetail.status=='completed'">{{$t('common.download')}}</el-button>
        <!--模板下载-->
      </div>
      <!--0-60为绿色、61-80橙色、80以上为红色。-->
      <el-form :model="formcapacityList" ref="formcapacityList" :rules="rulescapacityList">
        <el-table :data="formcapacityList.capacityList" ref="capacityList" border highlight-current-row max-height='420'>
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('supplierManage.Category1')" prop='categoryName1' align="center"></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('supplierManage.Category2')" prop='categoryName2' align="center"></el-table-column>
          <el-table-column show-overflow-tooltip v-for="(val,index) in tableColumnList" :prop="val.key" :key="index" :label="val.title" min-width="200">
            <template slot-scope="scope">
              <el-form-item :prop=" 'capacityList.' + scope.$index + '.' + val.key" :rules="[{ required: true, message: $t('visitPlan.noEmpty')},]" :class="changeBackgroung(val.title,scope.row[val.key])" v-if='val.title.indexOf("利用率") != -1'>
                <!-- <el-input :value="scope.row[val.key]+'%'" :disabled='index==0 || status!="new"' oninput="value=value.replace(/[^\d.]/g,'')"></el-input> -->
                <el-input :disabled='index==0 || status!="new"' v-model="scope.row[val.key]" oninput="value=value.replace(/[^\d.]/g,'')">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
              <el-form-item :prop=" 'capacityList.' + scope.$index + '.' + val.key" :rules="[{ required: true,message: '不能为空', trigger: 'blur' }]" v-else>
                <el-input v-model="scope.row[val.key]" :disabled='index==0 || status!="new"'></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
    <!-- <el-card class="box-card" v-if="emplFlag!='SUP'">产能明细表模板 SS产能详情的产能明细表模板不再展示。
            <div slot="header" class="clearfix">
                <span>{{$t('capacity.capacitylistTemplate')}}</span>
            </div>
            <el-upload style="float:left"
                        ref="upload"
                        action="upload"
                        :http-request="uploadConfirm"
                        :show-file-list="false"
                        multiple
                        v-if="capacityDetail.status=='completed'"
                        name="file">
                <el-button v-if="capacityDetail.status=='completed'" slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
            </el-upload>
            <el-table :data="fileList" border highlight-current-row class="table">
                <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId"  min-width="130px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>&lt;!&ndash;删除&ndash;&gt;
                    </template>
                </el-table-column>
            </el-table>
        </el-card> -->
    <el-card class="box-card" v-if="emplFlag == 'SUP'">
      <!--供应商产能明细表-->
      <div slot="header" class="clearfix">
        <span>{{$t('capacity.uploadConfirmSup')}}</span>
      </div>
      <el-table :data="fileList" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.template')" min-width="130px">
          <!--模版-->
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-upload v-if="supFileBtnShow" style="float:left" ref="upload" action="upload" :http-request="uploadConfirmSup" :show-file-list="false" multiple name="spFile">
        <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
      </el-upload>
      <el-table :data="supFileList" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="tmDocumentId" min-width="130px">
          <template slot-scope="scope">
            <el-link v-show="supFileBtnShow" type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import capacityApi from "@/api/capacity/capacity";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import { apiService } from "@/api/material/material-master-data";
import commonFun from "@/utils/commonFun";
export default {
  components: { IcSelect },
  data() {

    return {
      checkUtilizationRate: (rule, value, callback) => {
        if (commonFun.isEmpty(value)) {
          return callback(new Error(this.$t("visitPlan.noEmpty")));
        }
        let reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("sys.userList.inputEmail")));
        } else {
          callback();
        }
      },
      capacityDetail: {
        category1: '', category2: '',
        growthRate: '',
      },
      supplierName: '',
      ttSupplierCapacityId: '',
      columnNum: '',//一共有多少列
      formcapacityList: {
        capacityList: [],
      },
      tableColumnList: [],
      categoryList1: [],
      categoryList2: [],
      fileList: [],
      supFileList: [],
      supplierCapacityList: [],
      emplFlag: '',
      status: '',
      rulescapacityList: {},
      activeName: 'ssDoc',
      supFileBtnShow: true,
    }
  },
  computed: {
    isSupplier() {
      return commonFun.isSupplier();
    }
  },
  created() {
    this.ttCapacityId = this.$route.query.ttCapacityId;
    //用户所属系统
    this.emplFlag = localStorage.getItem('ms_emplFlag');
    // this.emplFlag = 'SUP';
    if (this.$route.query.ttCapacityId) {
      this.getDetail(this.$route.query.ttCapacityId)
    }
    this.getCategoryList()
    if (this.emplFlag == 'SUP') {
      this.getFiles();
      this.getSupFiles();
    } else {
      this.getFiles();
    }
  },
  methods: {
    changeBackgroung: function (column, val) {
      //0-60为绿色、61-80橙色、80以上为红色
      if (val) {
        if (column.indexOf("利用率") != -1) {
          if (val <= 60) {
            return "cell-green"
          } else if (val > 80) {
            return "cell-red"
          } else if (val <= 80 && val > 60) {
            return "cell-yellow"
          }

        }
      } else {
        return ""
      }
    },
    utilizationRate(val) {
      return val = val + '%'
    },
    blurInput(e, column) {
      let that = this
      let val = e.target.value
      if (column.indexOf("利用率") != -1) {
        // if(val<=60){
        //     that.$refs.inputBox.style.background = '#67C23A'
        //     // return "cell-green"
        // }else if(val>80){
        //     that.$refs.inputBox.style.background = 'red'
        //     // return "cell-red"
        // }else if(val<=80 && val>60){
        //     // return "cell-yellow"
        //     that.$refs.inputBox.style.background = '#E6A23C'
        // }else
        if (val == 0 || commonFun.isEmpty(val)) {
          that.$refs.inputBox.style.background = '#fff'
          // return ""
        }
      }
    },
    getDetail(ttCapacityId) {
      let that = this
      capacityApi.capacityInfo(ttCapacityId).then(res => {
        let TempTitle = res.data.titleList
        this.columnNum = res.data.titleList.length
        let TempCapacity = res.data.capacityList
        var TableColumnList = TempTitle.map(function (item, index) {
          let obj = {
            title: item,
            key: 'name' + index,
          };
          return obj;
        });
        let capacityList = []
        if (!!TempCapacity) {
          for (let i = 0, len = TempCapacity.length; i < len; i++) {
            var obj = {};
            for (var j = 0; j < TempCapacity[i].length; j++) {
              obj.delIds = i
              let name = 'name' + j
              obj[name] = TempCapacity[i][j]

            }
            capacityList.push(obj)
          }
        }
        capacityList.forEach(item => {
          item.categoryName1 = res.data.capacity.categoryName1
          item.categoryName2 = res.data.capacity.categoryName2
        })
        that.tableColumnList = TableColumnList
        that.formcapacityList.capacityList = capacityList

        that.supplierName = res.data.supplierName
        that.ttSupplierCapacityId = res.data.ttSupplierCapacityId
        that.capacityDetail = res.data.capacity
        apiService.findCategory({ categoryLevel: 2, pid: that.capacityDetail.category1 }).then((res) => {
          that.categoryList2 = res.data;
        });
        if (this.emplFlag == 'SUP') {
          that.status = res.data.supplierCapacityStatus
          if (res.data.supplierCapacityStatus == 'completed') {
            that.supFileBtnShow = false;
          }
          that.getFiles();
          that.getSupFiles();
        }
        that.supplierCapacityList = res.data.supplierCapacityList
      });
    },
    //
    copy(obj) {
      var newobj = obj.constructor === Array ? [] : {};
      if (typeof obj !== 'object') {
        return;
      }
      for (var i in obj) {
        newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
      }
      return newobj
    },
    saveDetail() {
      let that = this
      let capacityList = []
      let array = that.formcapacityList.capacityList
      var temp = this.copy(array)
      temp.forEach(function (e, index) {
        delete e.delIds
        delete e.categoryName1
        delete e.categoryName2
        var values = Object.values(e);
        capacityList.push(values)
      })
      // capacityList.forEach(function(e,index){
      //     e.shift()//把第一个删除标识删掉
      // })
      let data = {
        capacityList: capacityList,
        submit: false,
        ttSupplierCapacityId: that.ttSupplierCapacityId
      }
      console.log(data)
      capacityApi.saveCapacityDetail(data).then(res => {
        if (res.code == '200') {
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
        }
      });
    },
    submitDetail() {
      let that = this
      this.$refs.formcapacityList.validate(valid => {
        if (valid) {
          let capacityList = []
          let array = that.formcapacityList.capacityList;
          let temp = this.copy(array);
          temp.forEach(function (e, index) {
            delete e.delIds;
            delete e.categoryName1;
            delete e.categoryName2;
            var obj = e;
            var values = Object.values(obj);
            capacityList.push(values)
          })
          // capacityList.forEach(function (e, index) {
          //   e.shift()//把第一个删除标识删掉
          // })
          let data = {
            capacityList: capacityList,
            submit: true,
            ttSupplierCapacityId: that.ttSupplierCapacityId
          }
          console.log(data)
          capacityApi.saveCapacityDetail(data).then(res => {
            if (res.code == '200') {
              that.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    addDetail() {
      let that = this
      let len = this.formcapacityList.capacityList.length;
      let columnNum = this.columnNum
      let obj = {}
      for (let i = 0; i < columnNum; i++) {
        obj.delIds = len
        obj.categoryName1 = that.capacityDetail.categoryName1
        obj.categoryName2 = that.capacityDetail.categoryName2
        let name = 'name' + i
        if (i == 0) {
          // obj[name] = '广州夏晖物流成都分公司'
          obj[name] = that.supplierName
        } else {
          obj[name] = ''
        }

      }
      that.formcapacityList.capacityList.push(obj)

    },
    delDetatil() {
      let that = this
      let list = that.formcapacityList.capacityList;
      let rows = this.$refs.capacityList.selection;
      console.log(rows)
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      that.formcapacityList.capacityList = list;
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.capacityDetail.category2 = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.capacityDetail.category1 }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    //模板下载
    templateDownload: function () {
      capacityApi.templateDownload(this.ttCapacityId).then((res) => { })
    },
    //模版上传
    templateUpload(item) {
      let formData = new FormData();
      formData.append("file", item.file);
      capacityApi.fileUpload(formData, this.ttSupplierCapacityId).then((res) => {
        this.getDetail(this.ttCapacityId)
      })
    },
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then(res => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data;
        attachment.tsRecId = this.ttCapacityId;
        attachment.tsReckindId = "CAPACITY";
        fileService.saveFile(attachment).then(saveRes => {
          _this.getFiles();
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    uploadConfirmSup: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then(res => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data;
        attachment.tsRecId = _this.ttSupplierCapacityId;
        attachment.tsReckindId = "SUPPLIER_CAPACITY";
        fileService.saveFile(attachment).then(saveRes => {
          _this.getSupFiles();
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then(res => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess")
        });
        this.getSupFiles();
      });
    },
    getFiles() {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttCapacityId;
      attachment.tsReckindId = "CAPACITY";
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList = fileRes;
      });
    },
    getSupFiles() {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttSupplierCapacityId;
      attachment.tsReckindId = "SUPPLIER_CAPACITY";
      fileService.getFileList(attachment).then(fileRes => {
        this.supFileList = fileRes;
      });
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    dowloadSupZip: function (row) {
      let data = {
        ttCapacityId: row.ttCapacityId,
        ttSupplierCapacityId: row.ttSupplierCapacityId
      }
      capacityApi.zipDownload(data).then((res) => { })
    },
    dowloadAllSupZip: function () {
      let data = {
        ttCapacityId: this.ttCapacityId,
      }
      capacityApi.zipDownload(data).then((res) => { })
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}
.el-table {
  margin-top: 10px;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
</style>
<style lang="scss">
.cell-green .el-input__inner {
  background: #67c23a !important;
}
.cell-red .el-input__inner {
  background: #fb4e4e !important;
}
.cell-yellow .el-input__inner {
  background: #ffff00 !important;
}
.capacityDetail {
  .searchBox_bottom {
    margin-top: 20px;
    display: flex;
    .el-upload {
      display: block;
    }
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>
